import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const DirectPatientMessaging: React.FC<PropsType> = ({
  size = 50,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <g clip-path="url(#clip0_272_13130)">
        <path
          d="M7.91699 5.83325L38.9128 5.83325C44.1158 5.83325 48.3337 10.0511 48.3337 15.2542V15.2542C48.3337 20.4572 44.1158 24.6751 38.9128 24.6751H11.4128C6.03033 24.6751 1.66699 29.0384 1.66699 34.4208V34.4208C1.66699 39.8033 6.03032 44.1666 11.4128 44.1666H41.667"
          stroke="#003125"
          stroke-width="3.33333"
        />
        <rect
          x="38.333"
          y="40.8333"
          width="6.66667"
          height="6.66667"
          rx="3.33333"
          fill="white"
          stroke="#003125"
          stroke-width="3.33333"
        />
        <rect
          x="5"
          y="2.5"
          width="6.66667"
          height="6.66667"
          rx="3.33333"
          fill="white"
          stroke="#003125"
          stroke-width="3.33333"
        />
        <path
          d="M6.87506 22.0504L41.8679 12.2931L15.9731 28.2296L6.87506 22.0504Z"
          fill="#19FFBE"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linejoin="round"
        />
        <path
          d="M21.8707 31.9486L41.8676 12.293L35.0738 37.8212L21.8707 31.9486Z"
          fill="#19FFBE"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.3631 36.2227L15.9724 28.2297L41.8672 12.2932L17.3631 36.2227Z"
          fill="white"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_272_13130">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DirectPatientMessaging;
